module.exports = "data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAABIAAAASCAMAAABhEH5lAAAAVFBMVEUAAAAzMzMzMzMzMzMzMzMzMzMzMzMzMzMzMzMzMzMzMzMzMzMzMzMzMzMzMzMzMzMzMzMzMzMzMzMzMzMzMzMzMzMzMzMzMzMzMzMzMzMzMzMzMzPEWWtkAAAAHHRSTlMA/fKZKMluZd25ViIFAUO9Rj8jETPYqqJdDIh3ffr29AAAAKRJREFUGNNtj0kWxCAIREE0aBxj5u7737NDSHZdCwo/9XwAtwp5RE8FXtlauafUuVarZDLDOxzMdGfMKDZHqaO5ctkNAjZEx5JzGUqQKRleAkowFCAW5DeAgvIDE/guKM4AX7wKdA+YQDUiiSUEcypZhCharaIPqkcP+/G0i/qxQwvaklMPTVd9kK6qB6n0oH9ni6wLHNNpOTj7DnMjj2alluX1A8pwBX/iTSrEAAAAAElFTkSuQmCC"


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/icon_-.png
// module id = rhDH
// module chunks = 2